import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class subTaskTemplateSelectCtrl implements IController {

  selectedId: string;
  optionIds: any;
  isRequired: boolean;
  types: any;
  ngPlaceholder: string;
  noUnderline: boolean;
  onChange: Function;

  private subTasksTemplatesRef: any;
  private loaded: boolean;
  private searchTerm: string;
  private selectedTemplates: any;
  private selectedTemplate: any;
  private templateOptions: any;

  /* @ngInject */
  constructor(private IamRequests, private $mdSelect, private $log, private $q: IQService, private $subTasksTemplates) {
  }

  $onInit() {
    this.subTasksTemplatesRef = this.$subTasksTemplates();
    this.loaded = false;
    this.searchTerm = '';
    this.selectedTemplates = undefined;
    this.templateOptions = [];

    if (this.selectedId) {
      if (this.optionIds) {
        this._getByIds(this.optionIds);
      } else {
        this._getAll();
      }
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      if (!this.loaded) {
        this._getByIds(changes.selectedIds.currentValue);
      }
    }
  }

  /////////////////////////////////////////////////////

  onOpen() {
    if (!this.loaded) {
      if (this.optionIds) {
        return this._getByIds(this.optionIds);
      } else {
        return this._getAll()
      }
    } else {
      return this.$q.when();
    }
  }

  cancel() {
    this.$mdSelect.hide();
  }

  doneHideSelect() {
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  resetHideSelect() {
    this.searchTerm = '';
    this.onChange({template: undefined});
    this.$mdSelect.hide();
  }

  _getAll() {
    return this.subTasksTemplatesRef.$getAll({type: this.types})
      .then((templatesIds) => {
        return this._getByIds(templatesIds);
      })
      .catch((error) => {
        this.$log.error('Failed to get service areas @branchesMultiSelect@onOpen', error);
      });
  }

  _getByIds(ids) {
    return this.subTasksTemplatesRef.$asyncValues(ids)
      .then((templates) => {
        this.templateOptions = templates;
        this.selectedTemplate = _.find(templates, (t) => {
          return _.isEqual(this.selectedId, t.templateId);
        })
        this.loaded = true;
        return this.$q.when(templates)
      })
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTaskTemplateSelect', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      isRequired: '<?',
      types: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&'
    },
    template: require('./sub-task-template-select.html').default,
    controller: subTaskTemplateSelectCtrl
  });
